<mat-toolbar class="toolbar">
  <button mat-icon-button (click)="toggleMenu.emit()">
    <mat-icon>menu</mat-icon>
  </button>

  <!-- Breadcrumb ruta -->
  <div class="breadcrumb">
    <mat-icon class="home-icon" routerLink="/home">home</mat-icon>
    <span class="route-label">{{ shortenRoute }}</span>
  </div>

  <!-- <span class="title-toolbar">Costos integrales</span> -->
  <span class="spacer"></span>

  <!-- Sectores -->
  @if (profile; as userProfile) {
    @if (userProfile.user_sector.length > 0) {
      <div class="sector-container">
        <mat-form-field appearance="outline" class="sector-select" subscriptSizing="dynamic">
          <mat-select
            [(value)]="sectorSelected"
            (selectionChange)="changeSector($event.value)"
            panelClass="sector-panel"
          >
            @for (userSector of userProfile.user_sector; track userSector.sector.id) {
              <mat-option [value]="userSector.sector.id">
                {{ userSector.sector.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  }
  <!-- Grupos del usuario -->
  <div class="groups-container">
    @for (group of profile?.role_group; track group) {
      <span class="group-chip">{{ group.name }}</span>
    }
    @if (profile?.is_staff) {
      <span class="group-chip">Staff</span>
    }
    @if (profile?.is_superuser) {
      <span class="group-chip">Superuser</span>
    }
  </div>

  <!-- Usuario -->
  <button mat-button [matMenuTriggerFor]="userMenu" class="user-btn">
    <span class="user-name"> {{ profile?.first_name }} {{ profile?.last_name }} </span>
    <mat-icon>account_circle</mat-icon>
    <mat-icon class="chevron"> expand_more </mat-icon>
  </button>

  <mat-menu #userMenu="matMenu" class="icon-menu" xPosition="before">
    <button class="icon-button" mat-menu-item routerLink="/perfil">
      <span class="text-span"><mat-icon class="icon-size">person</mat-icon>Perfil</span>
    </button>
    <button class="icon-button" mat-menu-item (click)="profile && changePassword(profile)">
      <span class="text-span"
        ><mat-icon class="icon-size">lock_reset</mat-icon>Actualizar contraseña</span
      >
    </button>
    <mat-divider></mat-divider>
    <button class="icon-button" mat-menu-item (click)="logout()">
      <span class="text-span delete-span"
        ><mat-icon class="icon-size delete-icon">logout</mat-icon>Cerrar sesión</span
      >
    </button>
  </mat-menu>
</mat-toolbar>
